const TOKEN_TYPES = {
    TEXT: 'TEXT',
    LINK: 'LINK'
};

const DEFAULT_TOKEN = {
    pos: null,
    type: null,
    value: null
};

let tokens = [];
let rawText = '';
let readIndex = 0;
let readBuffer = '';

/************************/
/* MAIN LEXER FUNCTIONS */
/************************/
const initLexer = (text) => {
    rawText = text;
    readIndex = 0;
    tokens = [];
    clearBuffer();
}

const readNextToken = (char) => {
    let token = null;

    switch (char) {
        case '[':
            token = createLinkToken();
            break;
    }

    return token;
}

const createLinkToken = () => {
    const LINK_END_DELIMITER = ')';
    const LINK_REGEX = /\[(.+)\]\(([A-Za-z0-9-._~:/?#\[\]@!$&'\(\)*+,;%=]+)\)/;

    let char = peekChar();
    let linkBuffer = '';
    linkBuffer += currentChar();

    for (let peekBy = 1; char !== LINK_END_DELIMITER; ++peekBy) {
        char = peekChar(peekBy);

        if (char === null) { // Not a link or invalid link
            return null;
        }

        linkBuffer += char;
    }

    if (linkBuffer.match(LINK_REGEX)) {
        return createToken(TOKEN_TYPES.LINK, linkBuffer, readIndex);
    }

    return null;
};

const createTextToken = () => {
    let pos = readIndex - readBuffer.length;
    let text = readBuffer;
    return createToken(TOKEN_TYPES.TEXT, text, pos);
}

const createToken = (type, value, pos) => {
    const token = structuredClone(DEFAULT_TOKEN);
    token.type = type;
    token.value = value;
    token.pos = pos;
    return token;
};

/*********************/
/* SUPPORT FUNCTIONS */
/*********************/
const currentChar = () => {
    return rawText[readIndex];
}

const nextChar = () => {
    readIndex++;
    if (readIndex < rawText.length) {
        return rawText[readIndex];
    }
    return null;
}

const peekChar = (peekBy = 1) => {
    let peekIndex = readIndex + peekBy;
    if (peekIndex < rawText.length) {
        return rawText[peekIndex];
    }
    return null;
}

const clearBuffer = () => {
    readBuffer = '';
}

/**
 * Markdown Lexer
 * 
 * Use to perform lexical analysis to convert text to tokens for parser to use.
 * 
 * Honestly not the best implementation, but I wanted to try xD.
 * Best would be using class, but since we're not practicing class in this program
 * i've avoided using it.
 * 
 * @author Darrus Goh
 */
const MarkdownLexer = {
    TOKEN_TYPES,
    analyze: (text) => {
        initLexer(text);

        let char = currentChar();
        while (char !== null) {
            let token = readNextToken(char);

            if (token) {
                // Check if there's any text before this token
                if (readBuffer.length > 0) {
                    tokens.push(createTextToken());
                    clearBuffer();
                }

                tokens.push(token);
                readIndex = token.pos + token.value.length - 1; // -1 to account for current pos
            } else { // Invalid token, continue as per normal
                readBuffer += char;
            }

            char = nextChar();
        }

        // Convert any remaining text into Text Token
        if (readBuffer.length > 0) {
            tokens.push(createTextToken());
            clearBuffer();
        }

        return tokens;
    }
};

export default MarkdownLexer;